import type { Product } from "../domain/schemas";

export const SOURCE_CHECKED_AT = "2026-07-24T00:00:00.000Z";

export const officialSources = {
  b2bHome: "https://zh-tw.tasteliving2019.com/",
  enHome: "https://www.tasteliving2019.com/",
  cpet: "https://zh-tw.tasteliving2019.com/cpet",
  tritan: "https://zh-tw.tasteliving2019.com/tritan",
  sugarcane: "https://zh-tw.tasteliving2019.com/sugarcane-fiber",
  oem: "https://zh-tw.tasteliving2019.com/oem-obm-odm-service-process",
  certification: "https://www.livingforward.com.tw/about_living/quality_authentication/",
  productList:
    "https://www.livingforward.com.tw/product/?cookies_accepted=Y&items_per_page=128",
  cpetTumbler:
    "https://www.livingforward.com.tw/products-tw/product/tritan_tableware/cpet-cup-480ml/",
  cBento:
    "https://www.livingforward.com.tw/products-tw/product/tritan_tableware/c-bento-cpet-innch-box/",
  cpetCup:
    "https://www.livingforward.com.tw/product/%E5%93%A9%E7%9A%BF%E7%B5%90%E6%99%B6%E6%9D%AF/",
} as const;

const rawProducts: Product[] = [
  {
    id: "c-bento",
    slug: "c-bento",
    locale: "zh-TW",
    status: "published",
    translationStatus: "source",
    name: "哩皿潔晶餐盒 C-Bento",
    shortDescription: "可依用餐情境組合內盤的 CPET 餐盒。",
    sku: "ATL-A-01",
    category: "lunchbox",
    material: "CPET",
    price: { currency: "TWD", amount: 1090, source: "official" },
    priceStatus: "verified",
    inventory: { status: "in_stock", source: "official" },
    specifications: [
      { label: "整體", value: "193 × 193 × 70 mm" },
      { label: "底座", value: "1200 ml／CPET" },
      { label: "上蓋", value: "PP／1 入" },
    ],
    heatResistance: null,
    usage: ["使用方式待依正式商品資料確認"],
    image: "/assets/official/c-bento-card.webp",
    imageAlt: "哩皿潔晶餐盒 C-Bento 商品情境圖",
    certificationIds: ["cpet-product-reports"],
    knowledgeIds: ["cpet-guide"],
    sourceUrl: officialSources.cBento,
    sourceCheckedAt: SOURCE_CHECKED_AT,
    seo: {
      title: "哩皿潔晶餐盒 C-Bento｜哩皿食器",
      description: "查看 C-Bento 餐盒的官方規格、材質、價格與企業採購入口。",
    },
  },
  {
    id: "cpet-tumbler-480",
    slug: "cpet-tumbler-480",
    locale: "zh-TW",
    status: "published",
    translationStatus: "source",
    name: "哩皿潔晶隨行杯 單入組",
    shortDescription: "480 ml CPET 隨行杯，官方頁面提供三色選擇。",
    sku: "ALC-04-C",
    category: "cup-bottle",
    material: "CPET",
    price: { currency: "TWD", amount: 290, source: "official" },
    priceStatus: "verified",
    inventory: { status: "in_stock", source: "official" },
    specifications: [
      { label: "尺寸", value: "135 × 93 mm" },
      { label: "容量", value: "480 ml" },
      { label: "材質", value: "CPET" },
    ],
    heatResistance: "140℃",
    usage: ["可微波加熱", "可用電鍋蒸煮"],
    image: "/assets/official/hero-tumbler-mobile.webp",
    imageAlt: "哩皿 CPET 潔晶隨行杯商品圖",
    certificationIds: ["cpet-product-reports"],
    knowledgeIds: ["cpet-guide"],
    sourceUrl: officialSources.cpetTumbler,
    sourceCheckedAt: SOURCE_CHECKED_AT,
    seo: {
      title: "哩皿潔晶隨行杯 480ml｜哩皿食器",
      description: "查看 480 ml CPET 潔晶隨行杯的官方規格、使用方式與價格。",
    },
  },
  {
    id: "cpet-cup-200",
    slug: "cpet-cup-200",
    locale: "zh-TW",
    status: "published",
    translationStatus: "source",
    name: "哩皿潔晶杯單入",
    shortDescription: "200 ml CPET 潔晶杯。",
    sku: "ALT-A-026",
    category: "cup-bottle",
    material: "CPET",
    price: { currency: "TWD", amount: 200, source: "official" },
    priceStatus: "verified",
    inventory: { status: "in_stock", source: "official" },
    specifications: [
      { label: "尺寸", value: "90 × 84 mm" },
      { label: "容量", value: "200 ml" },
      { label: "材質", value: "CPET" },
    ],
    heatResistance: "140℃",
    usage: ["可微波加熱", "可用電鍋蒸煮"],
    image: "/assets/official/cpet-twelve-card.webp",
    imageAlt: "哩皿 CPET 潔晶食器組合情境圖",
    certificationIds: ["cpet-product-reports"],
    knowledgeIds: ["cpet-guide"],
    sourceUrl: officialSources.cpetCup,
    sourceCheckedAt: SOURCE_CHECKED_AT,
    seo: {
      title: "哩皿潔晶杯 200ml｜哩皿食器",
      description: "查看 200 ml CPET 潔晶杯的官方規格、耐熱與使用方式。",
    },
  },
  {
    id: "cpet-five-compartment-tray",
    slug: "cpet-five-compartment-tray",
    locale: "zh-TW",
    status: "published",
    translationStatus: "source",
    name: "哩皿潔晶五格餐盤（無上蓋）",
    shortDescription: "CPET 五格餐盤。",
    sku: "ALD-11-W01",
    category: "plate",
    material: "CPET",
    price: { currency: "TWD", amount: 495, source: "official" },
    priceStatus: "verified",
    inventory: { status: "unknown", source: "official" },
    specifications: [],
    heatResistance: null,
    usage: ["詳細規格與庫存待正式商品資料匯入"],
    image: "/assets/official/meal-tray-card.webp",
    imageAlt: "哩皿五格餐盤商品圖",
    certificationIds: ["cpet-product-reports"],
    knowledgeIds: ["cpet-guide"],
    sourceUrl: officialSources.productList,
    sourceCheckedAt: SOURCE_CHECKED_AT,
    seo: {
      title: "哩皿潔晶五格餐盤｜哩皿食器",
      description: "查看潔晶五格餐盤與企業大宗採購入口。",
    },
  },
  {
    id: "cpet-noodle-bowl",
    slug: "cpet-noodle-bowl",
    locale: "zh-TW",
    status: "published",
    translationStatus: "source",
    name: "哩皿潔晶麵碗單入",
    shortDescription: "CPET 潔晶麵碗。",
    sku: "PENDING-CUSTOMER-IMPORT",
    category: "bowl",
    material: "CPET",
    price: { currency: "TWD", amount: 350, source: "official" },
    priceStatus: "verified",
    inventory: { status: "unknown", source: "official" },
    specifications: [],
    heatResistance: null,
    usage: ["SKU、庫存與完整規格待正式商品資料匯入"],
    image: "/assets/official/cpet-tableware-card.webp",
    imageAlt: "哩皿 CPET 潔晶食器情境圖",
    certificationIds: ["cpet-product-reports"],
    knowledgeIds: ["cpet-guide"],
    sourceUrl: officialSources.productList,
    sourceCheckedAt: SOURCE_CHECKED_AT,
    seo: {
      title: "哩皿潔晶麵碗｜哩皿食器",
      description: "查看 CPET 潔晶麵碗與相關永續材質資訊。",
    },
  },
  {
    id: "cpet-round-plate-large",
    slug: "cpet-round-plate-large",
    locale: "zh-TW",
    status: "published",
    translationStatus: "source",
    name: "哩皿潔晶橢圓盤（大）",
    shortDescription: "CPET 潔晶橢圓盤。",
    sku: "ALD-04-C",
    category: "plate",
    material: "CPET",
    price: { currency: "TWD", amount: 345, source: "official" },
    priceStatus: "verified",
    inventory: { status: "unknown", source: "official" },
    specifications: [],
    heatResistance: null,
    usage: ["完整規格與庫存待正式商品資料匯入"],
    image: "/assets/official/cpet-tableware-card.webp",
    imageAlt: "哩皿 CPET 餐盤情境圖",
    certificationIds: ["cpet-product-reports"],
    knowledgeIds: ["cpet-guide"],
    sourceUrl: officialSources.cpetTumbler,
    sourceCheckedAt: SOURCE_CHECKED_AT,
    seo: {
      title: "哩皿潔晶橢圓盤｜哩皿食器",
      description: "查看哩皿潔晶橢圓盤與大宗採購入口。",
    },
  },
  {
    id: "cpet-chopsticks",
    slug: "cpet-chopsticks",
    locale: "zh-TW",
    status: "published",
    translationStatus: "source",
    name: "哩皿潔晶筷單雙入",
    shortDescription: "CPET 潔晶筷。",
    sku: "PENDING-CUSTOMER-IMPORT",
    category: "cutlery",
    material: "CPET",
    price: { currency: "TWD", amount: 175, source: "official" },
    priceStatus: "verified",
    inventory: { status: "unknown", source: "official" },
    specifications: [],
    heatResistance: null,
    usage: ["SKU、規格與庫存待正式商品資料匯入"],
    image: "/assets/official/cpet-twelve-card.webp",
    imageAlt: "哩皿潔晶餐具組合情境圖",
    certificationIds: ["cpet-product-reports"],
    knowledgeIds: ["cpet-guide"],
    sourceUrl: officialSources.productList,
    sourceCheckedAt: SOURCE_CHECKED_AT,
    seo: {
      title: "哩皿潔晶筷｜哩皿食器",
      description: "查看哩皿潔晶筷與相關 CPET 材質資訊。",
    },
  },
  {
    id: "cool-reusable-cup-700",
    slug: "cool-reusable-cup-700",
    locale: "zh-TW",
    status: "published",
    translationStatus: "source",
    name: "酷樂循環杯 700ml",
    shortDescription: "Tritan 循環杯。",
    sku: "PENDING-CUSTOMER-IMPORT",
    category: "cup-bottle",
    material: "Tritan",
    price: { currency: "TWD", amount: 790, source: "official" },
    priceStatus: "verified",
    inventory: { status: "unknown", source: "official" },
    specifications: [{ label: "容量", value: "700 ml" }],
    heatResistance: null,
    usage: ["完整規格、SKU 與庫存待正式商品資料匯入"],
    image: "/assets/official/cool-reusable-cup-card.webp",
    imageAlt: "哩皿酷樂循環杯商品圖",
    certificationIds: ["tritan-material-reports"],
    knowledgeIds: ["tritan-guide"],
    sourceUrl: officialSources.productList,
    sourceCheckedAt: SOURCE_CHECKED_AT,
    seo: {
      title: "酷樂循環杯 700ml｜哩皿食器",
      description: "查看酷樂循環杯與 Tritan 材質資訊。",
    },
  },
  {
    id: "recycled-planter",
    slug: "recycled-planter",
    locale: "zh-TW",
    status: "published",
    translationStatus: "source",
    name: "再生花盆",
    shortDescription: "官方 B 站列出的循環再生品項。",
    sku: "PENDING-CUSTOMER-IMPORT",
    category: "recycled",
    material: "Recycled material",
    price: null,
    priceStatus: "pending_confirmation",
    inventory: { status: "unknown", source: "official" },
    specifications: [],
    heatResistance: null,
    usage: ["價格、SKU、庫存與規格待客戶確認"],
    image: "/assets/official/business-banner-desktop.webp",
    imageAlt: "哩皿企業採購與循環合作官方形象圖",
    certificationIds: [],
    knowledgeIds: ["closed-loop-recycling"],
    sourceUrl: officialSources.b2bHome,
    sourceCheckedAt: SOURCE_CHECKED_AT,
    seo: {
      title: "再生花盆｜哩皿食器循環再生",
      description: "了解哩皿官方站所列的再生花盆與循環合作入口。",
    },
  },
];

export const products: Product[] = rawProducts;
